import React, { Component,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function UserNavigate(pageName) {
    const navigate = useNavigate();
  
    useEffect(() => {
    setTimeout(() => {
        navigate(pageName.pageName);
    }, 3000); 
    }, []);
}

class NavigationComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
          pageName: this.props.pageName,
        };
      }
    render() {
        return (
            <>  redirecting to login page...
            <UserNavigate pageName={this.state.pageName} />
            </>
        );
    }
}

export default NavigationComp;